import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface TabProps {
    label: ReactNode;
    value: any;
    active?: boolean;
    color?: string;
    // eslint-disable-next-line no-unused-vars
    onClick?: (value: any) => void;
    icon?: ReactNode;
    iconPlacement?: 'left' | 'right';
    className?: string;
    isButton?: boolean;
}

const StyledTab = styled.div<{ iconPlacement: string; color?: string }>`
    ${({ theme: { colors, typography }, iconPlacement, color }) => `
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: ${typography.size.desktop.paragraph.p2};
        line-height: ${typography.lineHeight[4]};
        font-weight: ${typography.weight.normal};
        color: ${colors.text.tertiary};
        &.tab-active {
            border-bottom: 2px solid ${color ? color : colors.primary};
            color: ${color ? color : colors.text.primary};
            font-weight: ${typography.weight.medium};
            padding-bottom: 10px;
            padding: 12px 0;
        }
        &.tab-button.tab-active {
            border-radius: 4px;
            background:${colors.background.secondary.v3};
            padding: 6px 0;
            border-bottom: none;
        }
        & > svg {
            ${
                iconPlacement == 'left'
                    ? `
                          padding-right: 4px;
                      `
                    : `
                          padding-left: 4px;
                      `
            };
        }
    `}
`;

const Tab: FC<TabProps> = ({
    label,
    value,
    active = false,
    onClick,
    className,
    icon,
    color,
    iconPlacement = 'left',
    isButton = false,
}) => (
    <StyledTab
        className={classNames('tab', isButton && 'tab-button', active && 'tab-active', className)}
        color={color}
        iconPlacement={iconPlacement}
        onClick={() => onClick && onClick(value)}
    >
        <>
            {icon && iconPlacement == 'left' && icon}
            {label}
            {icon && iconPlacement === 'right' && icon}
        </>
    </StyledTab>
);
export default Tab;
